import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPackageColorful = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 17,
	height: 18,
	fill: "none",
	viewBox: "0 0 17 18",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#E4BE98",
			d: "M7.50082 0.468722L0.942626 4.05719C0.361423 4.37521 0 4.98496 0 5.64748V12.0059C0 12.6457 0.337206 13.2381 0.887299 13.5647L7.42638 17.4472C7.99983 17.7877 8.71392 17.7858 9.28557 17.4423L15.7363 13.5661C16.2817 13.2383 16.6154 12.6486 16.6154 12.0122V5.46906C16.6154 4.79799 16.2447 4.18182 15.6518 3.86747L9.22015 0.457413C8.68159 0.171866 8.03557 0.176116 7.50082 0.468722Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#C18E5A",
			d: "M16.1704 4.28027C16.4525 4.60477 16.6156 5.02436 16.6157 5.46875V12.0127C16.6156 12.6489 16.2821 13.2387 15.7368 13.5664L9.28662 17.4424C8.96073 17.6382 8.5882 17.7217 8.22217 17.6953V9L16.1704 4.28027Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#F5F5F5",
			d: "M10.3817 6.71837L3.46143 2.58952L5.59373 1.38428L12.4171 5.45524C12.8739 5.72781 13.1537 6.22057 13.1537 6.75255V7.61374C13.1537 7.72014 13.0978 7.81869 13.0064 7.87321L11.5753 8.72705C11.3739 8.8472 11.1183 8.70209 11.1183 8.46758V8.01568C11.1183 7.4837 10.8385 6.99094 10.3817 6.71837Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#D6AB7F",
			d: "M8.22168 9.00049V17.6958C7.94574 17.6759 7.67322 17.5941 7.42676 17.4478L0.887695 13.5649C0.337602 13.2383 0 12.6461 0 12.0063V5.64795C5.44766e-06 5.20508 0.161694 4.78575 0.442383 4.46143L8.22168 9.00049Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#D9D9D9",
			d: "M11.3374 7.38404C11.3374 7.31243 11.3743 7.24587 11.435 7.20792L12.6812 6.42907C12.8195 6.34262 12.9989 6.44207 12.9989 6.6052V7.49997C12.9989 7.57158 12.9621 7.63814 12.9013 7.67609L11.6552 8.45494C11.5168 8.5414 11.3374 8.44195 11.3374 8.27882V7.38404Z"
		})
	]
});
const ForwardRef = forwardRef(SvgPackageColorful);
export default ForwardRef;
